export const VISITS_TABLE_COLUMN_HEADERS: { [index: string]: string } = {
  kbas: "KBA visits",
  visits: "Visits",
  leads: "Lead visits",
};
